import keyMirror from 'keymirror';

export const GuideDelivery = keyMirror({
  online: null,
  branch: null,
  both: null
});

export const GuideType = keyMirror({
  business: null,
  consumer: null,
  both: null
});



// WEBPACK FOOTER //
// ./src/model/Guide.js